"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = map;
function map(values, iteratee) {
  if (Array.isArray(values)) {
    return values.map(iteratee);
  }

  var result = Object.keys(values).map(function (key) {
    return iteratee(values[key], key, values);
  });

  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-form/lib/utils/map.js
// module id = 199
// module chunks = 0